
import atlasApi									from "../utils/atlasapi";
import {
	Button,
	Col,
	Row,
	Dropdown,
	Form
}												from "react-bootstrap";
import {
	PencilSimple,
	Lightning,
	Info,
	Eye,
	Trash,
	DotsThreeVertical,
	X,
	MapPinSimple
}												from "@phosphor-icons/react";
import DataTable								from 'react-data-table-component';
import EditNow									from "../components/EditNow";
import ReactDOM									from "react-dom/client";
import SubstationIcon							from "../assets/svg/SubstationIcon";
import Tool										from "../classes/Tool";
import LayerSubstations							from "../classes/LayerSubstations";

class ToolSubstation extends Tool {

	highlightedOnList	= [];
	hiddenSubstations	= [];
	allHidden			= false;
	modified			= false;

	type				= 'substations';
	itemsName			= 'substations';
	id					= 'id';
	infolayerId			= 'substations';
	
	constructor(p) {
		super();
		this.tc		= p;
		this.canvas	= this.tc.map.getCanvasContainer();
		if (ToolSubstation.tabIndex === undefined)
			ToolSubstation.tabIndex = null;
	}

	save(promise) {
		const { setters } = this.tc.draw.context;
		setters.setSaveState('saving');
		return promise
			.then((res) => { this.tc.checkOutdated(res); setters.setSaveState('finished'); return res; })
			.catch(err => { setters.setSaveState('error'); throw err; });
	}

	getToolLayer() {
		return LayerSubstations;
	}

	setCursor(cur) {
		this.tc.map.getContainer().classList.add(cur);
		return this;
	}

	remCursor(cur) {
		this.tc.map.getContainer().classList.remove(cur);
		return this;
	}

	init() {
		this.display();
		this.setEventHandlers();
	}

	exit() {
		if (this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(ToolSubstation.tabIndex);
		ToolSubstation.tabIndex = null;
		this.removeEventHandlers();
	}

	setEventHandlers() {
		if (!this.tc) return;
		this.setCursor("cursor-add-substation");
		this.tc.map.on('click', this.addSubstation);
		this.tc.map.on('contextmenu', this.handleRightClick);
		this.tc.map.on('mousedown', LayerSubstations.layerId, this.onDown);
		this.tc.map.on('touchstart', LayerSubstations.layerId, this.onTouchStart);
		this.setInOutListeners();
	}

	setInOutListeners() {
		this.tc.map.on('mouseenter', LayerSubstations.layerId, this.onEnter);
		this.tc.map.on('mouseleave', LayerSubstations.layerId, this.onLeave);
	}

	unsetInOutListeners() {
		this.tc.map.off('mouseenter', LayerSubstations.layerId, this.onEnter);
		this.tc.map.off('mouseleave', LayerSubstations.layerId, this.onLeave);
	}

	removeEventHandlers() {
		if (!this.tc) return;
		this.tc.map.off('click', this.addSubstation);
		this.tc.map.off('contextmenu', this.handleRightClick);
		this.tc.map.off('mousedown', LayerSubstations.layerId, this.onDown);
		this.tc.map.off('touchstart', LayerSubstations.layerId, this.onTouchStart);
		this.unsetInOutListeners();
		this.remCursor("cursor-add-substation");
		this.remCursor("cursor-grabbing");
	}

	onDown = (e) => {
		if (e.originalEvent.which != 1) return;
		e.preventDefault();
		this.unsetInOutListeners();
		this.getClickedSubstation(e);
		this.setCursor('cursor-grabbing');
		this.tc.map.mouseDown = true;
		this.tc.map.on('mousemove', this.onMove);
		this.tc.map.once('mouseup', this.onUp);
	}

	onMove = (e) => {
		const coords = e.lngLat;
		this.hasMoved = true;
		this.canvas.style.cursor = 'grabbing';
		LayerSubstations.data.features[this.currentSubstationIdx].geometry.coordinates = [coords.lng, coords.lat];
		this.setData(LayerSubstations.data);
	}

	onUp = (e) => {
		if (e.originalEvent.which != 1) return;
		const coords = e.lngLat;
		this.setInOutListeners();
		this.remCursor('cursor-grabbing');
		if (this.hasMoved && this.currentSubstationId) {
			this.updateSubstation(this.currentSubstationId, [coords.lng, coords.lat]);
			this.hasMoved = false;
		}
		this.currentSubstationId	= false;
		this.currentSubstationIdx	= false;
		delete this.tc.map.mouseDown;
		this.tc.map.off('mousemove', this.onMove);
		this.tc.map.off('touchmove', this.onMove);
	}

	onTouchStart = (e) => {
		if (e.points.length !== 1) return;
		e.preventDefault();
		this.getClickedSubstation(e);
		this.tc.map.mouseDown = true;
		this.tc.map.on('touchmove', this.onMove);
		this.tc.map.once('touchend', this.onUp);
	}

	getClickedSubstation(e) {
		var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerSubstations.layerId] });
		if (features[0]) {
			this.currentSubstationId	= features[0].id ?? features[0].properties.tempid;
			this.currentSubstationIdx	= features[0].properties.idx;
		}
	}

	onEnter = (e) => {
		this.remCursor("cursor-add-substation").setCursor("cursor-pointer");
		const id = e.features[0].id ?? e.features[0].properties.tempid;
		this.lastHoverId = id;
		this.highlightOnMap(id);
		this.highlightOnList(id);
	}

	onLeave = (e) => {
		this.remCursor("cursor-pointer").setCursor("cursor-add-substation");
		this.deHighlightOnMap(this.lastHoverId);
		this.deHighlightOnList(this.lastHoverId);
	}

	addSubstation = (e) => {
		this.closeContextMenu();

		if (this.tc.secondaryHandler) return;

		var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerSubstations.layerId] });
		if (features.length) {
			this.handleSubstationClick(features[0].id ?? features[0].properties.tempid);
			return;
		}

		e.originalEvent.stopPropagation();

		var newSubstation = {
			"geometry": {
				"coordinates": [e.lngLat.lng, e.lngLat.lat],
				"type": "Point"
			},
			"id":	'temp_' + Math.random().toString(36).substr(2, 9),
			"name":	"Substation " + (this.tc.scenario.substations.length + 1),
			"type":	"Feature"
		}

		this.tc.scenario.substations.push(newSubstation);
		this.resetLayer();
		this.tc.setScenario(this.tc.scenario);

		this.tc.map.fire("addSubstation", { scenario: this.tc.scenario, substation: newSubstation });

		if (this.tc.scenario.scenario_id) {
			this.save(
				atlasApi.createSubstation(
					this.tc.scenario.projectid,
					this.tc.scenario.scenario_id,
					e.lngLat.lat,
					e.lngLat.lng,
					newSubstation.name
				).then((res) => {
					if (res?.id) {
						const tempId = newSubstation.id;
						const idx = this.tc.scenario.substations.findIndex(s => s.id === tempId);
						if (idx > -1) {
							this.tc.scenario.substations[idx].id = res.id;
							this.tc.setScenario(this.tc.scenario);
							this.resetLayer();
						}
					}
					return res;
				})
			);
		}
	}

	removeSubstation = (e, sId) => {
		e?.originalEvent?.stopPropagation();
		var substationId;

		if (sId) {
			substationId = sId;
		} else {
			var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerSubstations.layerId] });
			if (features.length)
				substationId = features[0].id ?? features[0].properties.tempid;
		}

		if (!substationId) return;

		this.removeItem(substationId);
		this.resetLayer();

		this.tc.map.fire("removeSubstation", { scenario: this.tc.scenario, substation: substationId });
		this.display();
	}

	updateSubstation = (id, coordinates) => {
		if (!this.tc.scenario) return;

		var i = this.tc.scenario.substations.findIndex((elem) => elem.id == id);
		if (i > -1) {
			if (coordinates) {
				this.tc.scenario.substations[i].geometry.coordinates = coordinates;

				if (!isNaN(id) && this.tc.scenario.scenario_id)
					this.save(atlasApi.updateSubstation(this.tc.scenario.projectid, this.tc.scenario.scenario_id, id, coordinates[1], coordinates[0]));
			} else {
				if (!isNaN(id) && this.tc.scenario.scenario_id)
					this.save(atlasApi.deleteSubstation(this.tc.scenario.projectid, this.tc.scenario.scenario_id, id));

				delete this.tc.scenario.substations[i].geometry;

				if (typeof this.tc.scenario.substations[i].id !== 'number')
					this.tc.scenario.substations.splice(i, 1);
			}

			this.tc.scenario.modified = 1;
			this.tc.setScenario(this.tc.scenario);
		}
	}

	updateSubstationName(name, id, refresh) {
		if (!this.tc.scenario) return;

		var i = this.tc.scenario.substations.findIndex((elem) => elem.id == id);
		if (i > -1) {
			this.tc.scenario.substations[i].name = name ? name : 'Substation ' + id;

			if (!isNaN(id) && this.tc.scenario.scenario_id)
				this.save(atlasApi.updateSubstationName(this.tc.scenario.projectid, this.tc.scenario.scenario_id, id, this.tc.scenario.substations[i].name));

			this.tc.scenario.modified = 1;
		}

		if (refresh)
			this.resetLayer();
	}

	unselectAll() {
		if (this.currentSubstation?.id)
			this.updateMapFeatPop('id', this.currentSubstation.id, { selected: false });
	}

	select(id) {
		this.updateMapFeatPop('id', id, { selected: true });
	}

	handleSubstationClick = (id) => {
		this.unselectAll();
		this.currentSubstation = this.tc.scenario.substations.find((s) => s.id == id);
		this.select(id);
		this.display();
	}

	tName(row, index) {
		return row.name !== '' ? row.name : 'Substation ' + (index + 1);
	}

	highlightOnMap = (id) => {
		this.lastHoverId = id;
		this.updateMapFeatPop('id', id, { hover: true });
	}

	deHighlightOnMap = (id) => {
		this.updateMapFeatPop('id', id ?? this.lastHoverId, { hover: false });
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(this.idString(id));
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		this.display();
	}

	deHighlightOnList = (id) => {
		const index = this.highlightedOnList.indexOf(this.idString(id));
		if (index > -1) this.highlightedOnList.splice(index, 1);
		this.display();
	}

	handleRowClick = (row) => {
		this.unselectAll();
		this.currentSubstation = this.tc.scenario.substations.find((s) => s.id == row.id);
		this.select(row.id);
		this.display();
	}

	closeContextMenu() {
		if (!this.tc) return;
		var a;
		if (a = this.tc.map.getContainer().querySelector(".toolContextMenu"))
			a.remove();
	}

	handleRightClick = (e) => {
		e.originalEvent.preventDefault();

		var features = this.tc.map.queryRenderedFeatures(e.point, { layers: [LayerSubstations.layerId] });
		if (!features.length) return;

		var id = features[0].id ?? features[0].properties.tempid;

		var wrp = document.createElement("div");
		wrp.className = "toolContextMenu";
		wrp.style.left = e.point.x + 'px';
		wrp.style.top = e.point.y + 'px';

		this.closeContextMenu();
		this.tc.map.getContainer().appendChild(wrp);
		ReactDOM.createRoot(wrp).render(this.contextMenu(e, id));
	}

	handleHideAllSubstations = () => {
		if (!this.allHidden) {
			this.hiddenSubstations = this.tc.scenario.substations.map((s) => {
				this.handleToggleSubstation(s.id, true, true);
				return s.id;
			});
			this.allHidden = true;
		} else {
			const copy = this.hiddenSubstations.slice(0);
			copy.forEach((id) => { this.handleToggleSubstation(id, false, true); });
			this.hiddenSubstations = [];
			this.allHidden = false;
		}
		this.display();
	}

	handleToggleSubstation = (id, force, dontRefresh) => {
		const isHidden = typeof force === 'boolean' ? force : !this.hiddenSubstations.includes(id);

		if (isHidden) {
			if (!this.hiddenSubstations.includes(id)) this.hiddenSubstations.push(id);
		} else {
			const idx = this.hiddenSubstations.indexOf(id);
			if (idx > -1) this.hiddenSubstations.splice(idx, 1);
		}

		this.allHidden = this.hiddenSubstations.length === this.tc.scenario.substations.length;
		this.updateMapFeatPop('id', id, { invisible: isHidden });

		if (!dontRefresh) this.display();
	}

	handleRemoveSubstation = (e, id) => {
		this.removeSubstation(e, id);
		this.display();
		return true;
	}

	handleSelect = (e, row) => {
		if (!this.selected) this.selected = [];
		const idx = this.selected.findIndex((a) => a.id == row.id);
		if (idx !== -1) this.selected.splice(idx, 1);
		else this.selected.push(row);
		this.display();
	}

	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.tc.scenario.substations ?? []).filter(t => !!t.geometry);
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => s.id === d.id));
		if (allSelected) { this.selected = []; } else { this.selected = items.slice(); }
		this.display();
	}

	removeItem = (id) => {
		const i = this.tc.scenario.substations.findIndex(s => s.id == id);
		if (i > -1) {
			this.tc.scenario.substations.splice(i, 1);
			this.tc.setScenario(this.tc.scenario);
		}
	}

	handleBulkDelete = () => {
		if (!this.selected?.length) return;

		const persistedIds = this.selected.map(r => r.id).filter(id => !isNaN(id));

		this.selected.forEach(row => { this.removeItem(row.id); });
		this.selected = [];

		if (persistedIds.length && this.tc.scenario.scenario_id)
			this.save(atlasApi.bulkDeleteSubstations(this.tc.scenario.projectid, this.tc.scenario.scenario_id, persistedIds));

		this.resetLayer();
		this.display();
	}

	handleUpdateName(newName, id) {
		this.updateSubstationName(newName, id, true);
		this.display();
	}

	handleEditSubstation(e, id) {
		document.getElementById('edit-static-substation-' + id)
			.dispatchEvent(new MouseEvent("dblclick", { 'view': window, 'bubbles': true, 'cancelable': true }));
	}

	handleExitDetail = () => {
		this.currentSubstation = null;
		this.unselectAll();
		this.display();
	}

	isSelectedOnList = (row) => {
		return this.highlightedOnList.includes(this.idString(row.id));
	}

	contextMenu = (map_event, id) => {
		return (
			<>
				<button className="btn" onClick={() => { this.handleEditSubstation(map_event, id); this.closeContextMenu(); }}><PencilSimple size={20} /> Edit name</button>
				<button className="btn" onClick={() => { this.removeSubstation(map_event, id); this.closeContextMenu(); }}><Trash size={20} /> Remove Substation</button>
			</>
		);
	}

	display() {
		if (this.tc.serviceBar.current)
			ToolSubstation.tabIndex = this.tc.serviceBar.current.inject(
				this.currentSubstation ? this.renderDetail() : this.render(),
				ToolSubstation.tabIndex
			);
	}

	renderDetail() {
		if (!this.currentSubstation) return;
		const coords = this.currentSubstation.geometry?.coordinates;

		return (
			<div className="project-substations">
				<div className="title">
					{this.currentSubstation.name}
					<span onClick={() => { this.handleExitDetail(); }} className="btn btn-close alt float-end"><X size={16} /></span>
				</div>
				<div className="scroll">
					<div className="separator">
						<span>About this substation</span>
					</div>
					<div className="substation-detail">
						<Row className="basic-info mb-2">
							<Col xs="12">
								<MapPinSimple size={16} />
								<span>Name: </span>
								<EditNow
									id={'substation-' + this.currentSubstation.id}
									value={this.currentSubstation.name}
									editable={true}
									onUpdate={(val) => { this.handleUpdateName(val, this.currentSubstation.id); }}
								/>
							</Col>
						</Row>
						{coords &&
							<Row className="basic-info mb-2">
								<Col xs="12">
									<Lightning size={16} />
									<span>Location: </span>
									{coords[1].toFixed(5)}, {coords[0].toFixed(5)}
								</Col>
							</Row>
						}
					</div>
				</div>
			</div>
		);
	}

	render() {
		var substations = this.tc.scenario.substations
			? this.tc.scenario.substations.filter((t) => !!t.geometry)
			: (this.tc.scenario.substations = []);

		return (
			<div className="project-substations">
				<div className="title">
					Substations
				</div>
				<div className="scroll">
					<div className="content p-0">
						<DataTable
							data={substations}
							columns={[
								{
									name: <Eye onClick={this.handleHideAllSubstations} className={this.areAllHidden() ? 'opacity-25' : ''} size={16} />,
									id: 'id-eye',
									selector: row => row.id,
									format: (row) => (
										<Eye
											onClick={() => { this.handleToggleSubstation(row.id, undefined, false); }}
											id={"subs_" + row.id}
											data-id={row.id}
											className={this.hiddenSubstations.includes(row.id) || this.allHidden ? 'opacity-25' : ''}
											size={16}
										/>
									),
									width: "28px",
									style: { padding: '0' }
								},
								{
									name: (
										<Form.Check
											type="checkbox"
											checked={
												!!(this.tc.scenario.substations?.filter(t => !!t.geometry).length) &&
												this.tc.scenario.substations.filter(t => !!t.geometry).every(d => this.selected && this.selected.some(s => s.id === d.id))
											}
											ref={el => {
												if (el) el.indeterminate =
													!!(this.selected?.length) &&
													this.selected.length < (this.tc.scenario.substations?.filter(t => !!t.geometry).length ?? 0);
											}}
											onChange={this.handleSelectAll}
										/>
									),
									selector: this.tName,
									format: (row) => (
										<label className="checkbox-pad">
											<Form.Check
												type="checkbox"
												id={"check-" + row.id}
												checked={this.selected && this.selected.some((a) => a.id == row.id)}
												onClick={(e) => { this.handleSelect(e, row); }}
											/>
										</label>
									),
									width: "25px",
									style: { padding: '0px !important' }
								},
								{
									name: 'NAME',
									selector: this.tName,
									format: (row, index) => (
										<EditNow
											id={'substation-' + row.id}
											value={this.tName(row, index)}
											onClick={() => { this.handleRowClick(row); }}
											editable={true}
											onUpdate={(val) => { this.handleUpdateName(val, row.id); }}
										/>
									),
									sortable: true,
									width: "100%"
								},
								{
									name: '',
									cell: row => (
										<div className="context-menu" data-tag="allowRowEvents">
											<Dropdown className="minimal">
												<Dropdown.Toggle className="p-0 px-1" variant="default">
													<DotsThreeVertical size={16} />
												</Dropdown.Toggle>
												<Dropdown.Menu>
													<Dropdown.Item href="#" onClick={(e) => { this.handleEditSubstation(e, row.id); }}>
														<PencilSimple size={16} /> Edit name
													</Dropdown.Item>
													<Dropdown.Item href="#" onClick={(e) => { this.handleRemoveSubstation(e, row.id); }} className="text-danger">
														<Trash size={16} /> Remove substation
													</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
										</div>
									),
									width: "20px"
								}
							]}
							customStyles={{
								headCells: {
									style: {
										padding: '.5rem .3rem',
										minWidth: '0px !important',
										boxSizing: 'content-box',
										fontWeight: 'bold'
									}
								},
								cells: {
									style: {
										padding: '.5rem .3rem',
										minWidth: '0px !important',
										boxSizing: 'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color: 'var(--bs-body-color)',
										'&:last-child': { paddingRight: '1rem' }
									}
								},
								rows: {
									style: { minHeight: "0" },
									selectedHighlightStyle: { backgroundColor: 'red' }
								}
							}}
							onRowMouseEnter={row => this.highlightOnMap(row.id)}
							onRowMouseLeave={row => this.deHighlightOnMap(row.id)}
							onRowClicked={this.handleRowClick}
							selectableRowSelected={r => this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={
								<Row className="p-0 py-3 m-0">
									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no substations placed in this scenario.
									</Col>
								</Row>
							}
						/>

						{this.selected && !!this.selected.length &&
							<Row className="p-3 batch-action">
								<Col xs="6">
									{this.selected.length} Items selected
								</Col>
								<Col xs="6 text-end">
									<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
								</Col>
							</Row>
						}
						
						{(!this.selected || !this.selected.length) && !!this.tc.scenario?.substations?.length &&
							<Row className="p-3 batch-action">
								<Col xs="2">
									Total 
								</Col>
								<Col xs="10">
									{this.tc.scenario.substations.length } Substations 
								</Col>
							</Row>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default ToolSubstation;
